import React, { useState, useEffect } from "react";
import Page from "../pages/Page";
import PageContentWrapper from "../components/PageContentWrapper";
import uiManager from '../../config/ui.js';
import PAGES from '../data/PagesConstants';
import { getApi } from "../api/endpoints.js";

const DashboardPage = () => {
  const [stats, setStats] = useState({})
  const [statsApi] = getApi('stats');

  const fetchStats = async () => {
    try{
      const response = await statsApi({}).unwrap();
      setStats(response.data.stats);
    } catch(err) {
    }
  }

  useEffect(() => {
    fetchStats();
  }, [])

  const createKey = (hash) => {
    return camelCase(hash.split("_").join(" "));
  }

  function camelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index == -1 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, ' ');
  }

  const cardBgColors = [
    '#B4AE11', '#3FB7AE', '#46685B', '#046D8B', '#758918',
    '#5C6BC0', '#8BAF5F', '#A2C1D2', '#28A789', '#C0915C',
    '#af725f', '#8277cd', '#75b359', '#a55cc0', '#a7a528',
  ];

  return <Page
    uiPage={uiManager.getUiPage(PAGES.DashboardPage.name)}
    breadcrumbs={[{ label: "Dashboard" }]}
    className={'dashboard-page'}
  >
    <PageContentWrapper contentHeading={"Home"}>
    <div className="cards m-3 pb-3">
    {Object.keys(stats).map((key, index)=>{
      return <div 
       key={key}
       className="card"
        style={{ background: cardBgColors[index % cardBgColors.length], color: 'white', boxShadow: '2px 2px 5px 0px #555D50' }}
      >
        <span className="card-body">
          <h6>{createKey(key)}</h6>
        </span>
        {/* <span className="card-footer"> */}
        <span className="px-3">
          <p style={{fontSize: '26px'}}>{stats[key]}</p>
        </span>
        {/* </span> */}
      </div>
    })}
    </div>
    </PageContentWrapper>
  </Page>
};

export default DashboardPage;
